import { Component, OnInit, ViewEncapsulation, } from '@angular/core';
import { TranslationService } from '@alfresco/adf-core';
import { Constants as ConstantsShared, WorkflowService, ListWorkflowSort, SortDir, WorkflowListFilter, WorkflowListFilterDescription, WorkflowListFilterPriority, WorkflowListFilterDateStarted, WorkflowPriority, PageLayoutComponent, ToolbarComponent } from '@alfresco/aca-shared';
import { Constants } from '../constants';
import { Utils } from '../utils';
import { AppStore, getUserProfile, SnackbarErrorAction, SnackbarInfoAction } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import moment from 'moment';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmDialogComponent } from '@alfresco/adf-content-services';
import { MatDialog } from '@angular/material/dialog';
//import { Router } from '@angular/router';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatDatepickerModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    PageLayoutComponent,
    ToolbarComponent,
    MatProgressSpinnerModule,
    MatButtonToggleModule,
  ],
  encapsulation: ViewEncapsulation.None,
  selector: 'aca-my-workflows',
  templateUrl: './my-workflows.component.html',
  styleUrls: ['./my-workflows.component.scss']
})
export class MyWorkflowsComponent implements OnInit {

  actions = ConstantsShared.CUSTOM_PAGE_ACTIONS;

  workflowActive: string = 'active';
  currentSort: string = 'date';
  sortDateAsc: boolean = false;
  sortPriorityAsc: boolean = true;
  showFilters: boolean = false;
  priorityOptions: any[] = [];
  today = moment();

  filterForm = new FormGroup({
    description: new FormControl(''),
    priority: new FormControl('all'),
    dateStartedFrom: new FormControl(undefined),
    dateStartedTo: new FormControl(undefined),
  });
  userName: string;
  isLoading: boolean = false;

  currentPage: number = 1;
  selectedPage: number = 1;
  numberOfPages: number = 1;

  workflows: any[] = [];
  workflowsPaginated: any[] = [];

  constructor(
    private store: Store<AppStore>,
    private translation: TranslationService,
    private workflowService: WorkflowService,
    private dialogRef: MatDialog,
    //private router: Router,
  ) {
    this.priorityOptions = Utils.getPriorityOptions(this.translation);

    translation.translate.onLangChange.subscribe(() => {
      this.priorityOptions = Utils.getPriorityOptions(this.translation);
    });
  }

  ngOnInit() {
    this.isLoading = true;

    this.store.select(getUserProfile).subscribe((user) => {
      this.userName = user.id;
      this.onFormChange(null);
    });
  }

  onFilterFormChange(event) {
    this.onFormChange(event);
  }

  loadData = async () => {
    if (!this.userName)
      return;

    this.isLoading = true;

    const filters: WorkflowListFilter[] = [];
    if (this.showFilters) {
      const description = this.filterForm.get('description').value;
      if (description && description.length >= 3) {
        const filter = new WorkflowListFilterDescription(description);
        filters.push(filter);
      }
      
      const priority = this.filterForm.get('priority').value;
      if (priority && priority !== 'all') {
        const enumVal = priority as WorkflowPriority;
        const filter = new WorkflowListFilterPriority(enumVal);
        filters.push(filter);
      }

      const startedFrom = this.filterForm.get('dateStartedFrom').value,
            startedTo = this.filterForm.get('dateStartedTo').value;
      if (startedFrom || startedTo) {
        const startedFromValue = startedFrom ? startedFrom : null;
        const startedToValue = startedTo ? startedTo : null;
        const filter = new WorkflowListFilterDateStarted(startedFromValue, startedToValue);
        filters.push(filter);
      }
    }

    let sort: ListWorkflowSort,
        sortDir: SortDir;
    if (this.currentSort === 'date') {
      sort = ListWorkflowSort.DATE;
      sortDir = this.sortDateAsc ? SortDir.ASC : SortDir.DESC;
    } else if (this.currentSort === 'priority') {
      sort = ListWorkflowSort.PRIORITY;
      sortDir = this.sortPriorityAsc ? SortDir.ASC : SortDir.DESC;
    }

    await this.workflowService.listWorkflows(this.userName, this.workflowActive === 'active', filters, sort, sortDir)
      .then((data) => {
        const workflows = data.data;
        if (!workflows) {
          this.store.dispatch(new SnackbarErrorAction(this.translation.instant('CORE.MESSAGES.ERRORS.GENERIC')));
          return;
        }

        this.workflows = workflows;
        this.numberOfPages = Math.floor(workflows.length / Constants.LIST_PAGE_ITEM_COUNT) + 1;
        if (workflows.length % Constants.LIST_PAGE_ITEM_COUNT === 0)
          this.numberOfPages--;

        this.isLoading = false;
      })
      .catch((_) => {
        this.store.dispatch(new SnackbarErrorAction(this.translation.instant('CORE.MESSAGES.ERRORS.GENERIC')));
      });
    this.currentPage = this.selectedPage = 1;
    this.paginate();
  }

  onFormChange(event) {
    if (event?.value) this.selectedPage = this.currentPage = 1;
    this.loadData();
  }

  onFormEnter(event) {
    event.preventDefault();
    this.onFormChange(event);
  }

  onSortByDate(event) {
    if (this.currentSort !== 'date') {
      this.currentSort = 'date';
    } else {
      this.sortDateAsc = !this.sortDateAsc;
    }
    this.onFormChange(event);
  }

  onSortByPriority(event) {
    if (this.currentSort !== 'priority') {
      this.currentSort = 'priority';
    } else {
      this.sortPriorityAsc = !this.sortPriorityAsc;
    }
    this.onFormChange(event);
  }

  onToggleShowFilters() {
    this.showFilters = !this.showFilters;
  }

  onResetFilters(_) {
    this.filterForm.reset();
    this.filterForm.get('priority').setValue('all');
    this.onFormChange(null);
  }

  getWorkflowIconDetails(workflow: object): { icon: string, color: string } {
    const isActive = workflow['isActive'] || '';

    const workflowConditions = [
      {
        condition: isActive,
        icon: 'timelapse',
        color: 'circle-red'
      },
      {
        condition: !isActive,
        icon: 'task_alt',
        color: 'circle-green'
      },
      {
        condition: true,
        icon: 'comment',
        color: 'circle-yellow'
      }
    ];

    const matchingCondition = workflowConditions.find(item => item.condition);
    return matchingCondition ? { icon: matchingCondition.icon, color: matchingCondition.color } : { icon: 'timelapse', color: 'circle-red' };
  }

  getWorkflowSentValue(workflow: object) {
    const isoString = workflow['startDate'];
    const dueDate = Utils.dateFromISO8601(isoString);
    return Utils.formatDate(dueDate);
  }

  getWorkflowFromValue(workflow: object) {
    const initiator = workflow['initiator'];
    return `${initiator.firstName}${initiator.lastName ? (' ' + initiator.lastName) : ''}`;
  }

  getWorkflowPriorityValue(workflow: object) {
    return Utils.getPriorityTranslation(this.translation, workflow['priority']);
  }

  getWorkflowTypeValue(workflow: object) {
    return Utils.getWorkflowTypeName(workflow['name'], this.translation);
  }

  getWorkflowDueValue(workflow: object) {
    const dueDateIsoString = workflow['dueDate'];
    if (dueDateIsoString) {
      const dueDate = Utils.dateFromISO8601(dueDateIsoString);
      return Utils.formatDate(dueDate);
    } else {
      return '/';
    }
  }

  getWorkflowEndedValue(workflow: object) {
    const dueDateIsoString = workflow['endDate'];
    if (dueDateIsoString) {
      const dueDate = Utils.dateFromISO8601(dueDateIsoString);
      return Utils.formatDate(dueDate);
    } else {
      return '/';
    }
  }

  onClickWorkflow(workflowId: string) {
    // temporarily disabled, until the corresponding page is finished
    const workflowIdShort = workflowId.substring('activiti$'.length);
    //const url = `/workflow/workflow-details/${workflowIdShort}`;
    //this.router.navigateByUrl(url);
    const url = `#/workflow/workflow-details/${workflowIdShort}`;
    window.open(url, '_blank');
  }

  onRemoveWorkflow(workflowId: string) {
    this.dialogRef
      .open(ConfirmDialogComponent, {
        data: {
          title: 'APP.WORKFLOW.GENERAL.REMOVE_WORKFLOW',
          message: this.translation.instant('APP.WORKFLOW.GENERAL.REMOVE_WORKFLOW_PROMPT'),
          yesLabel: 'APP.DIALOGS.CONFIRM_DELETE.YES_LABEL',
          noLabel: 'APP.DIALOGS.CONFIRM_DELETE.NO_LABEL'
        },
        minWidth: '250px'
      })
      .afterClosed()
      .subscribe(async (result) => {
        if (result === true) {
          this.workflowService.cancelWorkflow(workflowId, this.workflowActive === 'complete')
            .then(() => {
              this.store.dispatch(new SnackbarInfoAction(this.translation.instant('APP.WORKFLOW.GENERAL.SUCCESSFULLY_REMOVED_WORKFLOW')));
              this.onFormChange(null);
            })
            .catch(_ => {
              this.store.dispatch(new SnackbarErrorAction(this.translation.instant('CORE.MESSAGES.ERRORS.GENERIC')));
            });
        }
      });
  }

  onJumpToPage() {
    if (this.selectedPage >= 1 && this.selectedPage <= this.numberOfPages) {
      this.currentPage = this.selectedPage;
      this.paginate();
    } else {
      this.selectedPage = this.currentPage;
    }
  }

  onNextPage() {
    if (this.currentPage < this.numberOfPages) {
      this.currentPage++;
      this.selectedPage = this.currentPage;
      this.paginate();
    }
  }

  onPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.selectedPage = this.currentPage;
      this.paginate();
    }
  }

  paginate() {
    this.workflowsPaginated = this.workflows.slice((this.currentPage - 1) * Constants.LIST_PAGE_ITEM_COUNT, this.currentPage * Constants.LIST_PAGE_ITEM_COUNT);
  }
}
